import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import { Button, Col, Collapse, Row, Table } from "reactstrap";
import DinamicAccordionInput from "../DinamicAccordionInput/DinamicAccordionInput";
import { validateImageURL } from "../../../utils/utils";
import { ALERT_TYPES, GLOBAL_CONSTANTS } from "../../../utils/Constants";
import { updateProviderPayment } from "../../../service/api";
import { useParams } from "react-router-dom";
import { useAuth } from "../../shared/AuthContext/AuthContext";

const AggregatorsAccordion = (props) => {
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState();
  const [providerList, setProviderList] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState();

  const [formValues, setFormValues] = useState();
  const [formErrors, setFormErrors] = useState();
  const [activeProviderMandatoryFields, setActiveProviderMandatoryFields] = useState();

  const { tenant, publicKey } = useParams();
  const { getDeviceInfo, getBrowserInfo, getIPAddress } = useAuth();

  const handleOpenOption = (index, selectedProvider) => {
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);

    if (newIndex === -1) {
      setSelectedProvider(null);
    } else {
      setActiveProviderMandatoryFields(selectedProvider?.mandatoryFields);
      setSelectedProvider(selectedProvider);
      setFormValues({});
      setFormErrors(null);
    }
  };

  const handleMandatoryFieldChange = (eventValue) => {
    const { name, value } = eventValue;
    setFormValues((lastValue) => ({ ...lastValue, [name]: value }));
    setFormErrors((lastValue) => ({ ...lastValue, [name]: null }));
  };

  const handleValidateProvidersImg = async (providers) => {
    for (const provider of providers) {
      const isValid = await validateImageURL(provider.image);
      provider.isImageValid = isValid;
    }

    setProviderList(providers);
    setIsLoading(false);
    props.onShowLoaderEventOut(false);
  };

  const handleValidateMandatoryFields = () => {
    let isValid = true;
    let errors = {};

    activeProviderMandatoryFields.forEach((field) => {
      const regex = new RegExp(field.fieldRegex);
      if (!formValues[field.fieldName] || !regex.test(formValues[field.fieldName])) {
        isValid = false;
        errors[field.fieldName] = field.errormessage;
      }
    });

    if (!isValid) {
      setFormErrors(errors);
    }

    return isValid;
  };

  const handleContinueWithPayment = () => {
    if (handleValidateMandatoryFields()) {
      updatePayment();
    }
  };

  const updatePayment = async () => {
    setIsProcessingPayment(true);
    props.onShowLoaderEventOut(true);

    const requestBody = {
      ...formValues,
      providerId: selectedProvider.aggregatorId,
    };

    const clientDataHeaders = {
      device: getDeviceInfo(),
      browser: getBrowserInfo(),
      ipAddress: await getIPAddress(),
    };

    updateProviderPayment(props.accessToken, requestBody, publicKey, tenant, clientDataHeaders)
      .then((result) => {
        const responseData = result.data;
        let paymentDataToContinue = {};

        if (responseData.responseCode === 1000) {
          if (responseData.structure != null && responseData.structure.url != null) {
            paymentDataToContinue.url = responseData.structure.url.url;

            if (responseData.structure.url.mode === GLOBAL_CONSTANTS.EMBEDDED_VALUE) {
              paymentDataToContinue.type = GLOBAL_CONSTANTS.EMBEDDED_VALUE;
            } else if (responseData.structure.url.mode === GLOBAL_CONSTANTS.REDIRECT_VALUE) {
              paymentDataToContinue.type = GLOBAL_CONSTANTS.REDIRECT_VALUE;
            } else {
              paymentDataToContinue.type = GLOBAL_CONSTANTS.MESSAGE_VALUE;
            }
          } else {
            paymentDataToContinue.message = responseData.structure.html_Instrucctions;
            paymentDataToContinue.type = GLOBAL_CONSTANTS.MESSAGE_VALUE;
          }
        } else {
          props.onShowNotificationEventOut({
            message: responseData.responseMessage,
            type: ALERT_TYPES.error,
          });

          return;
        }

        props.onContinueWithPaymentEventOut(paymentDataToContinue);
      })
      .catch((error) => {
        console.error("Error updating payment:", error);
        props.onShowNotificationEventOut({
          message: error.response.data.responseMessage,
          type: ALERT_TYPES.error,
        });
      })
      .finally(() => {
        setIsProcessingPayment(false);
        props.onShowLoaderEventOut(false);
      });
  };

  useEffect(() => {
    if (props.providerList.length > 0) {
      handleValidateProvidersImg(props.providerList);
    }
  }, [props.providerList]);

  return (
    <>
      {!isLoading && (
        <Table className="m-0">
          <tbody>
            {providerList.map((provider, index) => (
              <Fragment key={index}>
                <tr
                  onClick={() => handleOpenOption(index, provider)}
                  className={`accordion-item ${activeIndex === index && "active-item"}`}
                >
                  <td className="d-flex align-items-center">
                    <Col>
                      {provider.description?.trim() ? provider.description : provider.aggregator}
                    </Col>
                    <Col className="text-right">
                      {provider.isImageValid && (
                        <img
                          src={provider.image}
                          alt={provider.description}
                          style={{ maxHeight: "50px", maxWidth: "100px" }}
                          className="mr-2"
                        />
                      )}
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td className="p-0">
                    <Collapse isOpen={activeIndex === index}>
                      <Row className="m-3 ">
                        {provider.mandatoryFields.length > 0 ? (
                          provider.mandatoryFields?.map((mf, mfKey) => (
                            <Col md={6} key={mfKey} className="text-left">
                              <DinamicAccordionInput
                                isShowInput={activeIndex === index}
                                mandatoryFieldConfig={mf}
                                inputError={formErrors?.[mf.fieldName]}
                                onChangeEventOut={handleMandatoryFieldChange}
                                accessToken={props.accessToken}
                                onShowNotificationEventOut={props.onShowNotificationEventOut}
                              />
                            </Col>
                          ))
                        ) : (
                          <Col md={12}>
                            <p className="mt-3 mb-3">
                              No additional information is required for this payment method.
                            </p>
                          </Col>
                        )}
                      </Row>
                      <Row className="m-3 ">
                        <Col md={12}>
                          <Button
                            type="button"
                            color="primary"
                            className="w-100"
                            onClick={handleContinueWithPayment}
                            disabled={isProcessingPayment}
                          >
                            Continue with payment
                          </Button>
                        </Col>
                      </Row>
                    </Collapse>
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

AggregatorsAccordion.propTypes = {
  providerList: PropTypes.array,
  accessToken: PropTypes.string,
  onShowNotificationEventOut: PropTypes.func,
  onContinueWithPaymentEventOut: PropTypes.func,
  onShowLoaderEventOut: PropTypes.func,
};

export default AggregatorsAccordion;
